import React from 'react';
import { render } from 'react-dom';
import Landing from './containers/landing-router';
import './reset.scss';

render(
	<Landing />,
	document.getElementById('root')
);
